import React from "react";
import imageEmpty from "../assets/empty.svg";

export default function EmptyComponent() {
  return (
    <div
      style={{
        fontSize: 20,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        gap: 20,
        color: "#CED4DA",
      }}
    >
      <img src={imageEmpty} style={{ width: 200 }} alt="" />
      <div>ບໍ່ມີຂໍ້ມູນ</div>
    </div>
  );
}
